import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    vouchercolors: {},
};

export const voucherColorsSlice = createSlice({
    name: 'voucherColorsSlice',
    initialState,
    reducers: {
        
        getAgencyVoucherColors: (state, action) => {
            state.vouchercolors = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { getAgencyVoucherColors} = voucherColorsSlice.actions;

export default voucherColorsSlice.reducer;
